<template>
	<div>
		<b-navbar class="navbar" :toggleable="isToggleable" v-if="!$helpers.inIframe()">
			<b-nav-item class="d-block mr-2" v-if="showBackButton" @click="$router.go(-1)">
				<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg" svgClasses="rotate-180" width="20" height="20"/>
			</b-nav-item>
			<b-navbar-brand @click.once="redirectIfAuthenticated(true)" style="cursor: pointer;" :class="navbarBrandClasses">
				<img class="navbar-brand-img" :class="{ 'wider': inOpensalud360() }" :style="getLogoStyles" :src="getLogo" />
			</b-navbar-brand>
			<b-navbar-nav>
				<b-nav-item class="my-auto d-none d-xl-block" v-if="$store.state.session.user">
					<p data-hj-supress @click="goProfile" class="profile-link font-weight-bold">
						<img class="profile-pic mr-3 vertical-align-middle" :src="$store.state.session.user.photo" />
						{{ $store.state.session.user.name }}
					</p>
				</b-nav-item>
				<b-nav-item>
					<base-button variant="secondary" class="btn-dropdown d-inline-block px-0" borderColor="transparent" backgroundColor="transparent">
						<hamburguer-dropdown enablePortuguese :dontDisplayDropdown="isToggleable" :showLanguageSelector="false" class="dropdown">
							<template #menu-items>
								<div v-if="!inPanel && $store.getters['session/userIsPatient']" class="font-weight-bold">
									<base-button outline blue @click="() => $router.push('/patient')" size="sm">
										{{ $t('private-layout.home') }}
									</base-button>
									<hr>
								</div>
								<div v-if="menuServiceItems && menuServiceItems.length > 0">
									<div>
										<a @click="toggleShowServicesMenu" class="my-2 d-block font-weight-bold">
											{{  $t('private-layout.services') }}
											<base-icon src="/static-appopensalud/img/icons/morillas-svg-icons/primary/caret.svg" :color="BLUE_COLOUR" class="ml-1" :svgClasses="caretSubMenuClass" :height="12" :width="12"/>
										</a>
									</div>
									<CollapseTransition>
										<div v-if="showServicesMenu" class="submenu">
											<hr>
											<div v-for="(item, index) in menuServiceItems" :key="`list-items-${index}`">
												<a @click="item.action" class="my-2 d-block font-weight-bold">
													{{ item.title }}
												</a>
											</div>
											<hr>
										</div>
									</CollapseTransition>
									<hr v-if="!showServicesMenu">
								</div>
								<div v-if="$store.getters['session/userIsPatient']">
									<div v-for="i in notTabMenuItems"  :key="i.title">
										<a @click="onTabClick(i)" class="my-2 d-block font-weight-bold">
											{{ i.title }}
											<b-badge variant="info" v-if="i.bubble" class="ml-1">{{ i.bubble }}</b-badge>
										</a>
									</div>
									<hr>
								</div>
								<div>
									<div v-for="i in mainMenuItems" :key="i.title">
										<a @click="onTabClick(i)" class="my-2 d-block font-weight-bold">
											{{ i.title }}
											<b-badge variant="info" v-if="i.bubble" class="ml-1">{{ i.bubble }}</b-badge>
										</a>
									</div>
									<hr>
								</div>
								<lang-selector enablePortuguese class="lang-cnt text-center"></lang-selector>
								<hr>
								<div v-if="$store.getters['session/userIsPatient']">
									<a @click="$store.commit('layout/toggleChangeUserModalVisible')" class="font-weight-bold">{{ $t('menu.change-user') }}</a>
								</div>
								<div v-if="$store.state.session.user" @click="logOff" class="my-2">
									<a class="my-2 font-weight-bold">{{ $t('logOff') }}</a>
								</div>
							</template>
						</hamburguer-dropdown>
					</base-button>
				</b-nav-item>
			</b-navbar-nav>
		</b-navbar>
	</div>
</template>

<script>
import { BNavbar, BNavbarBrand, BNavbarNav, BNavItem, BBadge } from 'bootstrap-vue'
import layoutMixin from '@/mixins/layout.mixin'
import accountMixin from '@/mixins/account.mixin'
import HamburguerDropdown from '@/components/base/dropdown/HamburguerDropdown'
import LangSelector from '@/components/base/LangSelector'
import i18nMixin from '@/mixins/i18n.mixin'
import { mapGetters } from 'vuex'
import { BLUE_COLOUR } from '@/constants/colours'
import { inOpensalud360 } from '@/constants/platformNames'

const I18N_FILE = 'private-layout'

export default {
	components: {
		BNavbar,
    BNavbarNav,
    BNavbarBrand,
		BNavItem,
		HamburguerDropdown,
		LangSelector,
		BBadge
	},
	data () {
		return {
			BLUE_COLOUR,
			inOpensalud360
		}
	},
	mixins: [i18nMixin(I18N_FILE), layoutMixin, accountMixin],
	props: {
		menuItems: {
			type: Array,
			required: true
		},
		menuServiceItems: {
			type: Array,
			required: false,
			default: () => []
		}
	},
	computed: {
		...mapGetters({
			isToggleable: 'layout/isToggleable'
		}),
		mainMenuItems () {
			return this.menuItems.filter(i => i.mainMenu !== false)
		},
		notTabMenuItems () {
			return this.menuItems.filter(i => i.tab === false && i.mainMenu === false)
		},
		navbarBrandClasses () {
			return !this.inPanel ? 'mx-auto mx-lg-0' : {}
		}
	}
}
</script>

<style lang="scss" scoped>
	/deep/.navbar {
		@include container-padding-private;

		@include mobile {
			padding: {
				top: 0;
				bottom: 0;
			}
		}
	}
	hr {
		&:not(.divider){
			@include desktop {
				margin: {
					top: 1rem;
					bottom: 1rem;
				}
			}

			@include media(tablets, mobile) {
				margin: .75rem 0;
			}
		}
	}

	.profile-link {
		cursor: pointer;

		&:hover {
			text-decoration: underline;
		}
	}

	@include media(mobile, tablets) {
		.navbar-nav {
			margin-left: 0;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/PrivateLayoutMenu.vue